<template>
  <div class="column is-offset-half">
    <div class="content">
      <self-building-square-spinner
        :animation-duration="6000"
        :size="40"
        color="#0091D5"
      />
    </div>
  </div>
</template>

<script>
import { SelfBuildingSquareSpinner } from "epic-spinners";

export default {
  name: "LoadingAnimation",
  components: {
    SelfBuildingSquareSpinner
  }
};
</script>
